<template>
  <div class="proposition-price">
    <p
      v-if="showEarnings"
      class="proposition-price__net-payment"
    >
      Нетто-платіж {{ formatNumber(netPayment, { precision: 2 }) }} грн
    </p>

    <p class="proposition-price__amount">
      {{ formatNumber(price, { hideDecimalIfZero: true, precision: 2 }) }}
      <span class="proposition-price__currency">₴</span>
    </p>

    <AccentButton
      class="proposition-price__pass"
      :is-loading="isLoading"
      @click="$emit('select-offer')"
    >
      Оформити
    </AccentButton>

    <template v-if="showEarnings">
      <p class="proposition-price__earnings">
        Ваш заробіток {{ formatNumber(earningsValue, { precision: 2 }) }} грн
      </p>
      <p class="proposition-price__earnings-percent">
        ({{ earningsPercent }}%)
      </p>
    </template>
  </div>
</template>

<script>
import { NumberFormatter } from '@/shared/lib/number';
import { AccentButton } from '@/shared/ui/form';

const { formatNumber } = NumberFormatter();

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    showEarnings: {
      type: Boolean,
      default: false,
    },
    netPayment: {
      type: [Number, String],
      required: true,
    },
    price: {
      type: [Number, String],
      required: true,
    },
    thresholdPrice: {
      type: [Number, String],
      required: true,
    },
    earningsValue: {
      type: [Number, String],
      required: true,
    },
    earningsPercent: {
      type: [Number, String],
      required: true,
    },
  },
  components: { AccentButton },
  methods: {
    formatNumber,
  },
};
</script>

<style scoped lang="scss">
.proposition-price {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 190px;
  padding: 16px;

  &__net-payment {
    font-size: 12px;
    font-weight: 400;
    white-space: nowrap;
    color: #717680;
    margin: 0 0 12px;
  }

  &__amount {
    display: flex;
    align-items: center;
    font-size: 30px;
    font-weight: 600;
    margin: 0 0 20px;
  }

  &__currency {
    font-size: 16px;
    font-weight: 400;
    margin-left: 8px;
  }

  &__pass {
    justify-content: center;
    width: 100%;
    margin-bottom: 12px;
  }

  &__earnings,
  &__earnings-percent,
  &__threshold-price {
    font-size: 12px;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    color: #717680;
    margin: 0;
  }
}
</style>
